import { render, staticRenderFns } from "./customerAdd.vue?vue&type=template&id=52a4fa4d&scoped=true&"
import script from "./customerAdd.vue?vue&type=script&lang=js&"
export * from "./customerAdd.vue?vue&type=script&lang=js&"
import style0 from "./customerAdd.vue?vue&type=style&index=0&id=52a4fa4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a4fa4d",
  null
  
)

export default component.exports